export default "__VITE_ASSET__D8Nl38wv__"